// extracted by mini-css-extract-plugin
module.exports = {"container":"_3ZUML","text":"_1_bB9","cover":"_2oE6F"};